import "./App.css";
import Header from "./components/Header";
import Nav from "./components/Nav";
import Team from "./components/Team";
import JoinComunity from "./components/JoinComunity";
import "./css/story__team.css";
import OurStory from "./components/OurStory";
import WhitlistArea from "./components/WhitlistArea";
import RoadMap from "./components/RoadMap";
import TheDevelopment from "./components/TheDevelopment";
import Faqs from "./components/Faqs";
import Footer from "./components/Footer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MintPage from "./components/MintPage";
import { Link } from "react-router-dom";
import About from "./components/About";

function App() {
  return (
    <>
      <div className="App">
        {/* banner */}
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Nav hide={true} />
                <MintPage />
                <Footer />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <Nav hide={true} />
                <About />
                <Footer />
              </>
            }
          />
        </Routes>
      </div>
    </>
  );
}

export default App;
